import React from "react";
import { motion } from 'motion/react';
export function ScaleProgressGraphic({ color = 'rgba(168, 27, 141, 1)', colorLight = 'rgba(214, 129, 198, 1)' }) {
    const colorGlow = color.replace('1)', '0.2)');
    // Generate network nodes in a radial pattern
    const centerNodes = [
        { x: 120, y: 120, size: 12, delay: 0 }
    ];
    const innerNodes = Array.from({ length: 6 }, (_, i) => {
        const angle = (i * 60 * Math.PI) / 180;
        const radius = 50;
        return {
            x: 120 + radius * Math.cos(angle),
            y: 120 + radius * Math.sin(angle),
            size: 8,
            delay: 0.1 + i * 0.05
        };
    });
    const outerNodes = Array.from({ length: 12 }, (_, i) => {
        const angle = (i * 30 * Math.PI) / 180;
        const radius = 90;
        return {
            x: 120 + radius * Math.cos(angle),
            y: 120 + radius * Math.sin(angle),
            size: 6,
            delay: 0.4 + i * 0.03
        };
    });
    const allNodes = [...centerNodes, ...innerNodes, ...outerNodes];
    return (React.createElement("div", { style: { padding: '0px', width: '100%', height: '100%' } },
        React.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 240 240", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: "overflow-visible", preserveAspectRatio: "xMidYMid meet", style: { display: 'block', maxWidth: '100%', maxHeight: '100%' } },
            innerNodes.map((node, i) => (React.createElement(motion.line, { key: `inner-${i}`, x1: "120", y1: "120", x2: node.x, y2: node.y, stroke: colorGlow, strokeWidth: "2", initial: { pathLength: 0, opacity: 0 }, animate: { pathLength: 1, opacity: 1 }, transition: {
                    delay: node.delay,
                    duration: 0.4,
                    repeat: Infinity,
                    repeatDelay: 2.5,
                    repeatType: "loop"
                } }))),
            outerNodes.map((outerNode, i) => {
                const connectedInnerIndex = Math.floor(i / 2);
                const innerNode = innerNodes[connectedInnerIndex];
                return (React.createElement(motion.line, { key: `outer-${i}`, x1: innerNode.x, y1: innerNode.y, x2: outerNode.x, y2: outerNode.y, stroke: colorGlow, strokeWidth: "1.5", initial: { pathLength: 0, opacity: 0 }, animate: { pathLength: 1, opacity: 1 }, transition: {
                        delay: outerNode.delay,
                        duration: 0.3,
                        repeat: Infinity,
                        repeatDelay: 2.5,
                        repeatType: "loop"
                    } }));
            }),
            [30, 50, 70, 90].map((radius, i) => (React.createElement(motion.circle, { key: `ring-${i}`, cx: "120", cy: "120", r: radius, stroke: colorGlow, strokeWidth: "1", fill: "none", strokeDasharray: "4,4", initial: { scale: 0, opacity: 0 }, animate: {
                    scale: [0, 1, 1.1],
                    opacity: [0, 0.5, 0]
                }, transition: {
                    delay: i * 0.2,
                    duration: 2,
                    repeat: Infinity,
                    repeatDelay: 1,
                    repeatType: "loop"
                } }))),
            allNodes.map((node, i) => {
                // Replace center node (index 0) with spark
                if (i === 0) {
                    return (React.createElement(motion.g, { key: `node-${i}` },
                        React.createElement(motion.circle, { cx: node.x, cy: node.y, r: node.size * 1.5, fill: colorLight, initial: { scale: 0, opacity: 0 }, animate: {
                                scale: [0, 1, 1.2],
                                opacity: [0, 0.6, 0]
                            }, transition: {
                                delay: node.delay,
                                duration: 1,
                                repeat: Infinity,
                                repeatDelay: 2,
                                repeatType: "loop"
                            } }),
                        React.createElement(motion.g, { initial: { scale: 0 }, animate: {
                                scale: [1, 1.1, 1],
                                rotate: [0, 180, 360]
                            }, transition: {
                                delay: node.delay,
                                duration: 3,
                                repeat: Infinity,
                                repeatDelay: 1.7,
                                repeatType: "loop"
                            } },
                            React.createElement("g", { transform: `translate(${node.x - 18}, ${node.y - 18}) scale(2.571)` },
                                React.createElement("path", { d: "M13.98 5.74V8.28L7.88 7.38L12.84 11.06L11.04 12.86L7.36 7.9L8.26 14.02H5.72L6.62 7.9L2.94 12.86L1.14 11.06L6.1 7.38L1.49012e-08 8.28V5.74L6.1 6.64L1.14 2.96L2.94 1.16L6.62 6.12L5.72 -9.53674e-07H8.26L7.36 6.12L11.04 1.16L12.84 2.96L7.88 6.64L13.98 5.74Z", fill: colorLight })))));
                }
                return (React.createElement(motion.g, { key: `node-${i}` },
                    React.createElement(motion.circle, { cx: node.x, cy: node.y, r: node.size * 1.5, fill: colorGlow, initial: { scale: 0, opacity: 0 }, animate: {
                            scale: [0, 1, 1.2],
                            opacity: [0, 0.6, 0]
                        }, transition: {
                            delay: node.delay,
                            duration: 1,
                            repeat: Infinity,
                            repeatDelay: 2,
                            repeatType: "loop"
                        } }),
                    React.createElement(motion.circle, { cx: node.x, cy: node.y, r: node.size, fill: color, initial: { scale: 0 }, animate: { scale: 1 }, transition: {
                            delay: node.delay,
                            duration: 0.3,
                            repeat: Infinity,
                            repeatDelay: 2.7,
                            repeatType: "loop"
                        } })));
            }),
            React.createElement(motion.circle, { cx: "120", cy: "120", r: "20", stroke: color, strokeWidth: "2", fill: "none", initial: { scale: 0.5, opacity: 1 }, animate: {
                    scale: 5,
                    opacity: 0
                }, transition: {
                    duration: 2.5,
                    repeat: Infinity,
                    ease: "easeOut"
                } }))));
}
